export const GAZETTE_COVER_IMAGE_PREFIX = '/.quotion/themes/gazette/images/';
export const FIELDNOTES_COVER_IMAGE_PREFIX =
  '/.quotion/themes/fieldnotes/images/';

export function getCoverImageTheme(src: string) {
  if (src.startsWith(GAZETTE_COVER_IMAGE_PREFIX)) return 'Gazette';
  if (src.startsWith(FIELDNOTES_COVER_IMAGE_PREFIX)) return 'Fieldnotes';
  return undefined;
}
